/** Material Symbols Rounded glyph. The font is loaded once in index.html. */
export function Icon({ name, className = '' }: { name: string; className?: string }) {
  return (
    <span aria-hidden className={`icon ${className}`}>
      {name}
    </span>
  );
}
